import { render, staticRenderFns } from "./ListGroupAction.vue?vue&type=template&id=0b7b2a4a&"
import script from "./ListGroupAction.vue?vue&type=script&lang=js&"
export * from "./ListGroupAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports